import { makeVar } from '@apollo/client'

export const verticalCursorEventIndexVar = makeVar<number | null>(null)
